import styled from "styled-components";
export const VoucherWrap = styled.div `
    width: 100%;
	padding: 0.75rem 0.5rem 1px 0.5rem;
    box-sizing: border-box;
`;
const Circle = styled.i `
	position: absolute;
	display: block;
	width: 0.875rem;
	height: 0.875rem;
	border-radius: 50%;
`;
export const LCircle = styled(Circle) `
	left: -0.4375rem;
`;
export const RCircle = styled(Circle) `
	right: -0.4375rem;
`;
export const Text = styled.div `
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	font-size: 0.75rem;
	font-family: "SFProText-Heavy SFProText-Regular";
	font-weight: bold;
	position: relative;
	border-top: 1px dashed rgba(255, 255, 255, 0.5);
`;
